// 法语
import frLocale from 'element-ui/lib/locale/lang/fr'


const fr = {
  // ============= 登录 start ============
  "验证码": "Code de vérification",
  "登录": "Connexion",
  "请输入验证码": "Veuillez entrer le code de vérification",
  "验证码不正确!": "Code de vérification incorrect !",
  "请输入账号": "Veuillez entrer votre compte",
  "请输入密码": "Veuillez entrer votre mot de passe",
  "访问地址有误，请在shop后台核实": "L'adresse d'accès est incorrecte, veuillez vérifier dans le backend du magasin",
  // ============= 登录 end ============

  // ============= Layout start ============
  "全屏模式": "Mode plein écran",
  "首页": "Accueil",
  "此操作将退出登录, 是否继续?": "Cette opération vous déconnectera, voulez-vous continuer ?",
  "已取消退出": "Déconnexion annulée",
  "您有一个新订单": "Vous avez une nouvelle commande",
  "无法获取当前门店信息，请重新登录": "Impossible de récupérer les informations actuelles du magasin, veuillez vous reconnecter",
  "收银台": "Comptoir de paiement",
  "收银": "Encaisser",
  "桌台": "Table",
  "订单": "Commande",
  // ============= Layout end  ============

  // ============= 首页 start ============
  "查询会员": "Rechercher un membre",
  "商品改价": "Modifier le prix",
  "商品删行": "Supprimer l'article",
  "整单取消": "Annuler la commande",
  "挂单": "Maintenir la commande",
  "折扣": "Remise",
  "抹零": "Arrondir",
  "请输入内容": "Veuillez entrer le contenu",
  "收银员": "Caissier",
  "店内就餐": "Manger sur place",
  "打包带走": "à emporter",
  "商品名称": "Nom de l'article",
  "商品价格": "Prix de l'article",
  "商品数量": "Quantité de l'article",
  "应收": "Montant à payer",
  "包装费": "Frais d'emballage",
  "优惠": "Remise",
  "数量": "Quantité",
  "件": "Pièce",
  "实收": "Montant reçu",
  "收款": "Recevoir le paiement",
  "请选择商品": "Veuillez sélectionner des articles",
  "确定要删除": "êtes-vous sûr de vouloir supprimer",
  "提示": "Conseil",
  "确定": "Confirmer",
  "取消": "Annuler",
  "请先将购物车内的商品挂单或结账后再取单": "Veuillez mettre en attente ou passer à la caisse les articles dans le panier avant de récupérer la commande",
  "确定要整单取消吗?": "êtes-vous sûr de vouloir annuler la commande ?",
  "请输入会员手机号查询会员，输入完毕后点击确认": "Veuillez entrer le numéro de téléphone du membre pour le rechercher, puis cliquez sur confirmer",
  "请输入会员手机号": "Veuillez entrer le numéro de téléphone du membre",
  "会员昵称": "Pseudo du membre",
  "余额总计": "Solde total",
  "退出": "Sortir",
  "该用户不存在": "Cet utilisateur n'existe pas",
  "折扣抹零": "Remise/Arrondi",
  "当前价格": "Prix actuel",
  "改价": "Modifier le prix",
  "实付价格": "Prix réel",
  "请输入实付价格": "Veuillez entrer le prix réel",
  "优惠折扣": "Taux de remise",
  "请输入优惠折扣": "Veuillez entrer le taux de remise",
  "抹分": "Arrondir au dixième le plus proche",
  "抹角": "Arrondir au dollar le plus proche",
  "四舍五入到角": "Arrondir au dixième le plus proche",
  "四舍五入到元": "Arrondir au dollar le plus proche",
  "确 定": "Confirmer",
  "价格不能为空": "Le prix ne peut pas être vide",
  "折扣不能为空": "La remise ne peut pas être vide",
  "修改价格": "Modifier le prix",
  "本次售价": "Prix de vente actuel",
  "请输入本次售价": "Veuillez entrer le prix de vente actuel",
  "清空": "Effacer",
  "确认": "Confirmer",
  "商品详情": "Détails de l'article",
  "单位": "Unité",
  "规格": "Spécifications",
  "加料": "Ingrédients supplémentaires",
  "取 消": "Annuler",
  "现金收款": "Paiement en espèces",
  "余额收款": "Paiement par solde",
  "其他方式": "Autres méthodes",
  "应收金额": "Montant à Recevoir",
  "用户通过店内扫码等方式进行支付，确认用户支付成功后，点击确认付款即可完成付款操作。": "Les clients peuvent payer en utilisant des codes QR en magasin et d'autres méthodes. Après avoir confirmé le paiement réussi, cliquez sur 'Confirmer le paiement' pour finaliser la transaction.",
  "微信支付": "Paiement par WeChat",
  "支付宝支付": "Paiement par Alipay",
  "pos刷卡": "Paiement par carte POS",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Veuillez entrer l'ID du membre pour le rechercher, puis cliquez sur confirmer",
  "请输入会员ID": "Veuillez entrer l'ID du membre",
  "登录会员仅作为积分累计，无法享受其他优惠。": "Les membres connectés ne peuvent accumuler que des points et ne sont pas éligibles pour d'autres remises.",
  "取消收款": "Annuler le paiement",
  "订单总价": "Prix total de la commande",
  "挂单时间": "Temps d'attente de la commande",
  "删除": "Supprimer",
  "取单": "Récupérer la commande",
  "多语言小票打印": "Impression de ticket multilingue",
  "打印语言": "Langue d'impression",
  "中文": "Chinois",
  "英语": "Anglais",
  "德语": "Allemand",
  "法语": "Français",
  "西班牙语": "Espagnol",
  "意大利语": "Italien",
  "克罗地亚": "Croate",
  "斯洛文尼亚": "Slovène",
  "匈牙利语": "Hongrois",
  "塞尔维亚语": "Serbe",
  // ============= 首页 end   ============

  // ============= 桌台 start ============
  "未开台": "Non ouvert",
  "已开台": "Table ouverte",
  "就餐中": "Dîner en cours",
  "刷新": "Actualiser",
  "整单清空": "Effacer la commande entière",
  "转台": "Changer de table",
  "打印预结单": "Imprimer le devis préliminaire",
  "催菜": "Accélérer la commande",
  "人数": "Nombre de convives",
  "订单来源": "Source de la commande",
  "请点击左侧桌号台": "Veuillez cliquer sur le numéro de table à gauche",
  "点选已开台桌台，可以在此查看点餐信息。": "Sélectionnez une table ouverte pour voir les détails de la commande ici.",
  "服务费": "Frais de service",
  "税费": "Impôt",
  "协助点餐": "Aider à commander",
  "协助加餐": "Aider à ajouter des articles",
  "结账": "Payer",
  "完成": "Terminer",
  "价格": "Prix",
  "请选择": "Veuillez sélectionner",
  "确定要打印小票吗?": "êtes-vous sûr de vouloir imprimer le reçu ?",
  "确定要关闭桌台并取消订单吗?": "êtes-vous sûr de vouloir fermer la table et annuler la commande ?",
  "请选择桌号": "Veuillez sélectionner un numéro de table",
  "就餐人数": "Nombre de convives",
  "下单": "Passer la commande",
  "返回": "Retour",
  "确定要商品删行吗?": "êtes-vous sûr de vouloir supprimer la ligne de l'article ?",
  "请选择就餐人数": "Veuillez sélectionner le nombre de convives",
  // ============= 桌台 end ============

  // ============= 订单 start ============
  "下单时间": "Heure de commande",
  "起始时间": "Heure de début",
  "店内订单": "Commande sur place",
  "自提订单": "Commande à emporter",
  "外卖订单": "Commande de livraison",
  "名称": "Nom",
  "支付时间": "Heure de paiement",
  "消费方式": "Méthode de paiement",
  "状态": "Statut",
  "单价": "Prix unitaire",
  "金额": "Montant",
  "税率": "Taux d'imposition",
  "税费金额": "Montant de l'impôt",
  "邮箱地址": "Adresse e-mail",
  "今天": "Aujourd'hui",
  "昨天": "Hier",
  "一周": "Une semaine",
  "搜索": "Recherche",
  "待完成": "à compléter",
  "已完成": "Terminé",
  "已取消": "Annulé",
  "全部": "Tout",
  "顾客信息": "Informations client",
  "用户昵称": "Pseudo utilisateur",
  "手机号": "Numéro de téléphone",
  "收货地址": "Adresse de livraison",
  "取单号": "Numéro de retrait de commande",
  "就餐方式": "Mode de restauration",
  "订单号": "Numéro de commande",
  "订单金额": "Montant de la commande",
  "订单优惠": "Remise de la commande",
  "实付金额": "Montant réel payé",
  "支付方式": "Méthode de paiement",
  "备注信息": "Remarques",
  "期望配送时间": "Heure de livraison prévue",
  "取餐时间": "Heure de retrait",
  "配送费": "Frais de livraison",
  "退款金额": "Montant du remboursement",
  "准备中": "En préparation",
  "出餐中": "En cours de préparation",
  "待取餐": "En attente de retrait",
  "订单信息": "Informations de la commande",
  "税费详情": "Détails de l'impôt",
  "取消订单": "Annuler la commande",
  "打印小票": "Imprimer le reçu",
  "出餐": "Servir les plats",
  "确认送达": "Confirmer la livraison",
  "退款": "Remboursement",
  "已退款": "Remboursé",
  "请输入订单号": "Veuillez entrer le numéro de commande",
  "至": "à",
  "开始日期": "Date de début",
  "结束日期": "Date de fin",
  "发送账单": "Envoyer la facture",
  "请输入邮箱地址": "Veuillez entrer votre adresse e-mail",
  "确定要催菜吗?": "êtes-vous sûr de vouloir accélérer la commande ?",
  "确定要完成订单吗?": "êtes-vous sûr de vouloir compléter la commande ?",
  "确定要出餐吗?": "êtes-vous sûr de vouloir servir les plats ?",
  "确定要发送账单吗?": "êtes-vous sûr de vouloir envoyer la facture ?",
  "邮箱不能为空": "L'e-mail ne peut pas être vide",
  "确定要取消订单吗?": "êtes-vous sûr de vouloir annuler la commande ?",
  "是否确认此操作?": "êtes-vous sûr de vouloir confirmer cette opération ?",
  "上传文件只能是excel格式!": "Le fichier téléchargé doit être au format Excel !",
  "上传文件大小不能超过 10MB!": "La taille du fichier téléchargé ne peut pas dépasser 10 Mo !",
  "正在处理,请等待": "Traitement en cours, veuillez patienter",
  "本次处理失败": "échec du traitement cette fois-ci",
  "总金额": "Montant total",
  "可退款金额": "Montant remboursable",
  "请输入退款金额": "Veuillez entrer le montant du remboursement",
  "超出可退款金额": "Dépasse le montant remboursable",
  "404错误页面": "Page d'erreur 404",
  "合计": "Total",
  "份": "Part",
  "余额支付": "Paiement du Solde",
  "线下支付(现金支付)": "Paiement en Ligne (Paiement en Espèces)",
  "线下支付(微信支付)": "Paiement en Ligne (Paiement avec WeChat Propre)",
  "线下支付(支付宝支付)": "Paiement en Ligne (Paiement avec Alipay Propre)",
  "线下支付(POS刷卡支付)": "Paiement en Ligne (Paiement avec Carte POS)",
  "进行中": "En Cours",
  "待付款": "Paiement en Attente",
  "待配送": "En Attente de Livraison",
  "配送中": "En Livraison",
  "待接单": "En Attente d'Acceptation",
  "待取货": "En Attente de Retrait",
  "已配送": "Livré",
  "已收货": "Marchandise Reçue",
  "待收货": "En Attente de Réception",
  "待取消": "En Attente d'Annulation",
  "会员": "Membre",
  "商家": "Marchand",
  "供应商": "Fournisseur",
  "分销": "Distribution",
  "通知": "Notification",
  "已付款": "Déjà Payé",
  "用户下单": "Commande de l'Utilisateur",
  "收银台下单": "Commande au Comptoir",
  "扫码下单": "Commande par Scan",
  "团购下单": "Commande en Groupe",
  "商城订单": "Commande du Magasin",
  "积分商城订单": "Commande du Magasin de Points",
  "余额充值订单": "Commande de Recharge de Solde",
  "购卡订单": "Commande de Carte",
  "券包订单": "Commande de Pack de Coupons",
  "配送员押金订单": "Commande de Caution du Livreur",
  "团购订单": "Commande en Groupe",
  "下单减库存": "Réduction de Stock lors de la Commande",
  "付款减库存": "Réduction de Stock lors du Paiement",
  "商家配送": "Livraison par le Marchand",
  "外卖配送": "Livraison à Domicile",
  "到店自提": "Retrait en Magasin",
  "快递配送": "Livraison Express",
  "个人中心": "Espace Personnel",
  ...frLocale
}


export default fr



// WEBPACK FOOTER //
// ./src/i18n/langs/fr.js